import addError from '../../../utils/error.jsx';

export function request() {
    return {
        type: 'SYSTEM_SETTINGS_GET_CASHOUT_SETTINGS_REQUEST'
    };
}

export function error(errors) {
    addError(errors);
    return {
        type: 'SYSTEM_SETTINGS_GET_CASHOUT_SETTINGS_ERROR',
        errors
    };
}

export function finish(data) {
    return {
        type: 'SYSTEM_SETTINGS_GET_CASHOUT_SETTINGS_FINISH',
        data
    };
}
